// The two motion engines on the marketing site divide the page between them
// (#3201). reveal.ts and counter.ts run at DOMContentLoaded and handle the
// simple entries; choreography.ts lazy-loads GSAP after idle and owns the
// hero's release, the line-by-line headlines, the pinned chapters and their
// washes. An element belongs to exactly one of them: anything inside a
// [data-choreo] subtree is the choreographer's and the observers skip it, so
// nothing is ever animated twice, and if the GSAP chunk never arrives the
// choreographer's elements simply stand still in their served state.
export const CHOREO_ATTRIBUTE = "data-choreo";
export const CHOREO_READY = "data-choreo-ready";
export const LINES_ATTRIBUTE = "data-choreo-lines";

export function claimed(element: Element): boolean {
  return element.closest(`[${CHOREO_ATTRIBUTE}]`) !== null;
}

export function unclaimed<T extends Element>(elements: T[]): T[] {
  return elements.filter((element) => !claimed(element));
}

// A block already on screen must never be hidden so it can fade back in, the
// rule reveal.ts established: anything within a tenth of a viewport of the
// fold when the engine arms is left as served, its entrance already played.
export function shouldArm(rectTop: number, viewportHeight: number): boolean {
  return rectTop > viewportHeight * 0.9;
}
